import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import Card, { CardBody } from '../../components/bootstrap/Card';
import PageWrapper from '../PageWrapper/PageWrapper';
import Page from '../Page/Page';
import ContentRoutes from './ContentRoutes';
import ErrorBoundary from './ErrorBoundary';

const LOADING = (
	<PageWrapper>
		<Page>
			<div className='row h-100'>
				<div className='col-lg-6'>
					<Card stretch>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
				<div className='col-lg-6'>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
			</div>
		</Page>
	</PageWrapper>
);

const Content = () => {
	const location = useLocation();
	return (
		<main className='content'>
			<ErrorBoundary resetKey={location.pathname}>
				<Suspense fallback={LOADING}>
					<ContentRoutes />
				</Suspense>
			</ErrorBoundary>
		</main>
	);
};

export default Content;